export default {
    namespaced: true,
    state: {
        id: '',
        list: []
    },
    mutations: {
        SET_TOP_FUNDS_LIST_ID(state, id) {
            state.id = id;
        },
        SET_TOP_FUNDS_LIST(state, list) {
            state.list = list;
        }
    }
}


